var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Másolás '+this.actualTable.year+' -> ' +_vm.nextYear()),expression:"'Másolás '+this.actualTable.year+' -> ' +nextYear()"}]},[_c('a',{staticClass:"akg-table-copy btn btn-light",on:{"click":function($event){_vm.coppy()}}},[_c('i',{staticClass:" fa fa-arrow-right "})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d08f83a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CoppyKetRowTable.vue
// module id = U0Kv
// module chunks = 0